import React from 'react';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DebriefPopoverTitle from 'ff/debrief/common/components/DebriefPopoverTitle';
import { WhatsNewItem } from 'ff/debrief/models';

interface Props {
    anchorEl: HTMLElement | null;
    onClose: () => void;
    rows: WhatsNewItem[];
    onRowClick: (id: string) => void;
}

const WhatsNewPopover: React.FC<Props> = ({
    anchorEl,
    onClose,
    rows,
    onRowClick,
}) => {
    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            slotProps={{
                paper: {
                    sx: {
                        backgroundColor: 'white',
                        borderRadius: '2px 2px 0px 0px',
                    },
                },
            }}
            sx={{
                '& .MuiPaper-root': { mt: 1 },
            }}
        >
            <Box data-testid="whats-new-popover">
                <DebriefPopoverTitle onClose={onClose}>
                    What&#39;s New
                </DebriefPopoverTitle>

                {rows.map((row, index) => (
                    <Box
                        key={row.id}
                        id={row.id}
                        sx={{
                            padding: '12px 16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            borderBottom:
                                rows.length - 1 === index
                                    ? 'none'
                                    : '1px solid #BECAD4',
                            gap: '8px',
                            cursor: 'pointer',
                            '&:hover': { backgroundColor: '#F0F0F0' },
                        }}
                        onClick={() => onRowClick(row.id)}
                    >
                        <Box
                            sx={{
                                width: row.completed ? 6 : 7,
                                height: row.completed ? 6 : 7,
                                borderRadius: '50%',
                                backgroundColor: row.completed
                                    ? 'lightGray'
                                    : '#24AE43',
                            }}
                        />

                        <Typography
                            sx={{
                                fontSize: '13px',
                                fontStyle: 'normal',
                                fontWeight: '700',
                                lineHeight: '16px',
                                color: '#203040',
                            }}
                        >
                            {row.title}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Popover>
    );
};

export default WhatsNewPopover;
